module.exports = __webpack_public_path__ + "web-assets/img/emtpy.9a97a933.png";